import { render, staticRenderFns } from "./QuotationHall.vue?vue&type=template&id=0c88e3ec&scoped=true"
import script from "./QuotationHall.vue?vue&type=script&lang=js"
export * from "./QuotationHall.vue?vue&type=script&lang=js"
import style0 from "./QuotationHall.vue?vue&type=style&index=0&id=0c88e3ec&prod&lang=css"
import style1 from "./QuotationHall.vue?vue&type=style&index=1&id=0c88e3ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c88e3ec",
  null
  
)

export default component.exports